import React, { useState } from 'react'
// import AlsoKnownAs from '../AlsoKnownAs'
import TextAreaWithLink from './TextAreaWithLink'
import UpdatePersonExtendedInfo from '../../../Services/Mutations/UpdatePersonExtendedInfo'
import { toast } from 'react-toastify'
import { ToastStyle } from '../../Data/MovieStaticData'
import { Auth } from 'aws-amplify'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'

function PersonalAndBackGroundInfo(props) {
  const {
    activeSection,
    handleSectionClick,
    personalAndBackGroundInfo,
    setPersonalAndBackGroundInfo,
    section,
    getUpdatedData,
    personData,
    setLoader,
  } = props
  const [changesMade, setChangesMade] = useState(false)
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const handleTextAreaChange = (newValue, index) => {
    const updatedInfo = [...personalAndBackGroundInfo]
    updatedInfo[index].answer_En = Array.isArray(newValue[0]) ? newValue[0] : [newValue[0]]
    updatedInfo[index].answer_Te = Array.isArray(newValue[1]) ? newValue[1] : [newValue[1]]
    setPersonalAndBackGroundInfo(updatedInfo)
    setChangesMade(true)
  }

  const savePersonalAndBackGroundInfo = async () => {
    setLoader(true)
    const input = {
      PK: personData.PK,
      SK: personData.SK,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
    }
    const labelInput = {}
    personalAndBackGroundInfo.forEach(item => {
      if (item.field_En && item.answer_En && item.answer_En.toString()) {
        labelInput[item.field_En] = item.answer_En
      }

      if (item.field_Te && item.answer_Te && item.answer_Te.toString()) {
        labelInput[item.field_Te] = item.answer_Te
      }
    })
    const inputkey = '__typename'
    if (labelInput[inputkey] !== undefined) {
      delete labelInput[inputkey]
    }

    input.personalAndBackgroundInfo = labelInput
    try {
      const update = await UpdatePersonExtendedInfo(input)
      if (update.statusCode === '200') {
        toast.success(`${update.statusMessage}`, ToastStyle)
        setChangesMade(false)
        getUpdatedData()
        setLoader(false)
        // window.location.reload(false)
      } else {
        toast.error('failed to update try again')
        setLoader(false)
      }
    } catch (error) {
      setLoader(false)
      console.error('Error in SubmitExtendedInfo:', error.message)
    }
  }

  return (
    <div
      id={section}
      className={`accordion-item ${
        activeSection === section || activeSection === 'all' ? 'active' : ''
      }`}
    >
      <h2 className='accordion-header' id='headingThree'>
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseThree'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseThree'
          onClick={() => handleSectionClick(section)}
          style={{ color: 'white' }}
        >
          <span>Personal and Background Info</span>
          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      <div
        id='collapseThree'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingThree'
        data-bs-parent='#accordion'
      >
        {personalAndBackGroundInfo.map((info, index) => (
          <>
            {info && info.field_En && info.field_En === 'height' ? (
              <TextAreaWithLink
                key={index}
                labels={[info.field_En]}
                placeholders={[info.question_En]}
                value={[info.answer_En || '']}
                onChange={newValue => handleTextAreaChange(newValue, index)}
                setChangesMade={setChangesMade}
                section={'personalAndBackgroundInfo'}
              />
            ) : (
              <TextAreaWithLink
                key={index}
                labels={[info.field_En, info.field_Te]}
                placeholders={[info.question_En, info.question_Te]}
                value={[info.answer_En || '', info.answer_Te || '']}
                onChange={newValue => handleTextAreaChange(newValue, index)}
                setChangesMade={setChangesMade}
                section={'personalAndBackgroundInfo'}
              />
            )}
          </>
        ))}
        <div
          className='d-flex'
          style={{ justifyContent: 'center', alignItems: 'center', gap: '5px', marginTop: '5px' }}
        >
          <button
            className='btn btn-success'
            onClick={() => {
              setChangesMade(false)
              savePersonalAndBackGroundInfo()
            }}
            disabled={!changesMade}
          >
            save
          </button>
          <button
            className='btn btn-secondary'
            onClick={() => {
              setChangesMade(false)
              getUpdatedData()
            }}
            disabled={!changesMade}
          >
            cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default PersonalAndBackGroundInfo
